import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import {
  createYourDetailsSlice,
  YourDetailsSlice,
} from './storeSlices/yourDetails';
import {
  CombinedSlice,
  createCombinedSlice,
} from './storeSlices/combinedDetails';
import {
  HighwaysDetailsSlice,
  createHighwaysDetailsSlice,
} from './storeSlices/highwaysDetails';

export const useHighwaysStore = create<
  YourDetailsSlice & HighwaysDetailsSlice & CombinedSlice
>()(
  persist(
    (...a) => ({
      ...createYourDetailsSlice(...a),
      ...createHighwaysDetailsSlice(...a),
      ...createCombinedSlice(...a),
    }),
    {
      name: 'report-it-highways-storage', // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);
